import { AccordionHtmlContent } from "@/components/catalogue/AccordionHtmlContent";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ACCORDION_TITLE_CLASS } from "@/lib/accordion-content";

interface AuctionsAccordionProps {
  auctionCalculated: string | null;
  t: (key: string) => string;
}

export function AuctionsAccordion({
  auctionCalculated,
  t,
}: AuctionsAccordionProps) {
  if (!auctionCalculated) return null;

  return (
    <AccordionItem value="auctions">
      <AccordionTrigger className={ACCORDION_TITLE_CLASS}>
        {t("singleArtworkSubtitleAuction")}
      </AccordionTrigger>
      <AccordionContent>
        <AccordionHtmlContent html={auctionCalculated} richText />
      </AccordionContent>
    </AccordionItem>
  );
}
